import { Icon, IconProps } from "@chakra-ui/react";

export const IconColumnView = (props: Omit<IconProps, "css" | "children">) => (
    <Icon viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2" />
            <rect x="11.5" y="3.5" width="1" height="17" stroke="currentColor" />
        </g>
    </Icon>
);
